import { COLUMN_DEFINITIONS } from '@/src/components/game/Leaderboard/leaderboard.config';
import { LeaderboardTeam } from '@/src/types/JamLeaderboard';
import { i18nKeys } from '@/src/utils/i18n.utils';
import { RankingStrategyType } from '@/src/constants/shared/ranking-strategy';
import { Box, SpaceBetween, Table } from '@amzn/awsui-components-react';
import { useTranslation } from 'react-i18next';

const TeamMetricsLeaderboard = ({
  showTeamDetails,
  leaderboard,
  isLoading,
  showOriginalTeamName,
  index,
  numOfChallenges,
  rankingStrategy,
}: {
  showTeamDetails: (selectedTeamName: string | null) => void;
  leaderboard: LeaderboardTeam[];
  isLoading: boolean;
  showOriginalTeamName: boolean;
  index: number;
  numOfChallenges: number;
  rankingStrategy?: RankingStrategyType;
}) => {
  const { t } = useTranslation();
  return (
    <Table
      key={`leaderboad-list-${index}`}
      variant="embedded"
      columnDefinitions={COLUMN_DEFINITIONS(showTeamDetails, numOfChallenges, showOriginalTeamName, rankingStrategy)}
      items={leaderboard}
      wrapLines
      sortingDisabled
      empty={
        <Box margin={{ vertical: 'xs' }} textAlign="center" color="inherit">
          <SpaceBetween size="m">
            <b>{t(i18nKeys.jamDashboard.leaderboard.table.emptyMessage)}</b>
          </SpaceBetween>
        </Box>
      }
      loading={isLoading}
    />
  );
};

export default TeamMetricsLeaderboard;
